import { useCallback, useEffect, useState } from 'react';
import { supabase } from './supabase';

interface UseUserRoleResult {
  role: string | null;
  loading: boolean;
  error: string | null;
  refresh: () => Promise<void>;
}

export function useUserRole(userId?: string | null): UseUserRoleResult {
  const [role, setRole] = useState<string | null>(null);
  const [loading, setLoading] = useState<boolean>(Boolean(userId));
  const [error, setError] = useState<string | null>(null);

  const refresh = useCallback(async () => {
    if (!userId) {
      setRole(null);
      setLoading(false);
      setError(null);
      return;
    }

    setLoading(true);
    try {
      const { data, error } = await supabase
        .from('user_roles')
        .select('role')
        .eq('user_id', userId)
        .maybeSingle();

      if (error) throw error;

      setRole(data?.role ?? null);
      setError(null);
    } catch (_error) {
      setRole(null);
      setError('Unable to load user role.');
    } finally {
      setLoading(false);
    }
  }, [userId]);

  useEffect(() => {
    refresh();
  }, [refresh]);

  return { role, loading, error, refresh };
}
